import * as React from "react";
const SvgFolder = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.5 6.83341C2.5 5.89999 2.5 5.43328 2.68166 5.07676C2.84144 4.76316 3.09641 4.50819 3.41002 4.3484C3.76654 4.16675 4.23325 4.16675 5.16667 4.16675H8.0621C8.46975 4.16675 8.67357 4.16675 8.86539 4.2128C9.03545 4.25363 9.19802 4.32097 9.34714 4.41235C9.51534 4.51542 9.65946 4.65954 9.94772 4.9478L10.0523 5.05237C10.3405 5.34062 10.4847 5.48475 10.6529 5.58781C10.802 5.6792 10.9646 5.74654 11.1346 5.78736C11.3264 5.83341 11.5303 5.83341 11.9379 5.83341H14.8333C15.7668 5.83341 16.2335 5.83341 16.59 6.01507C16.9036 6.17486 17.1586 6.42983 17.3183 6.74343C17.5 7.09995 17.5 7.56666 17.5 8.50008V13.1667C17.5 14.1002 17.5 14.5669 17.3183 14.9234C17.1586 15.237 16.9036 15.492 16.59 15.6518C16.2335 15.8334 15.7668 15.8334 14.8333 15.8334H5.16667C4.23325 15.8334 3.76654 15.8334 3.41002 15.6518C3.09641 15.492 2.84144 15.237 2.68166 14.9234C2.5 14.5669 2.5 14.1002 2.5 13.1667V6.83341Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgFolder;
